<div class="checkbox">
    <input type="checkbox" class="checkbox__input" [formControl]="control">
    <p class="checkbox__text" [class.error]="control.invalid && control.touched">{{ label }}</p>
</div>